// Central datafil for Munkgaard Træbyg ApS

export const contactInfo = {
  name: "Munkgaard Træbyg ApS",
  address: "Kragelundvej 51, Kragelund, 8600 Silkeborg",
  mapsUrl: "https://www.google.com/maps/place/Kragelundvej%2051,%208600%20Silkeborg",
  mapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2218.490786520336!2d9.431289377484393!3d56.19946487325983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464bfd6389779357%3A0x8673752e2553952f!2sKragelundvej%2051%2C%208600%20Silkeborg!5e0!3m2!1sda!2sdk!4v1718444000000!5m2!1sda!2sdk",
  phone: "+45 30 94 38 90",
  phoneRaw: "+4530943890",
  email: "jacob@munkgaardtraebyg.dk",
  cvr: "45051048",
  facebook: "https://www.facebook.com/profile.php?id=61574206957056#",
  instagram: "https://www.instagram.com/munkgaard_traebyg/"
};

export const menuItems = [
  { label: "Forside", href: "/" },
  { 
    label: "Om os", 
    href: "/om-os",
    children: [
      { label: "Om os", href: "/om-os" },
      { label: "Vores styrker", href: "/vores-styrker" }
    ]
  },
  { 
    label: "Vi tilbyder", 
    href: "/vi-tilbyder",
    children: [
      { 
        label: "Udhuse", 
        href: "/vi-tilbyder/udhuse",
        children: [
          { label: "Garage og carport", href: "/vi-tilbyder/udhuse/garage-og-carport" },
          { label: "Anneks", href: "/vi-tilbyder/udhuse/anneks" },
          { label: "Skur", href: "/vi-tilbyder/udhuse/skur" }
        ]
      },
      { label: "Tilbygning", href: "/vi-tilbyder/tilbygning" },
      { 
        label: "Nybyggeri i træ", 
        href: "/vi-tilbyder/nybyggeri-i-trae",
        children: [
          { label: "Sommerhus", href: "/vi-tilbyder/nybyggeri-i-trae/sommerhus" },
          { label: "Helårshus", href: "/vi-tilbyder/nybyggeri-i-trae/helaarshus" }
        ]
      },
      { label: "Totalrenovering", href: "/vi-tilbyder/totalrenovering" },
      { 
        label: "Service", 
        href: "/vi-tilbyder/service",
        children: [
          { label: "Gulv/væg/loft", href: "/vi-tilbyder/service/gulv-vaeg-loft" },
          { label: "Tag", href: "/vi-tilbyder/service/tag" },
          { label: "Beklædning og udhæng", href: "/vi-tilbyder/service/beklaedning-og-udhaeng" },
          { label: "Køkken og interiør", href: "/vi-tilbyder/service/koekken-og-interioer" },
          { label: "Døre/vinduer", href: "/vi-tilbyder/service/doere-vinduer" },
          { label: "Terrasser og uderum", href: "/vi-tilbyder/service/terrasser-og-uderum" }
        ]
      }
    ]
  },
  { label: "Galleri", href: "/referencer" },
  { label: "Kontakt os", href: "/kontakt" }
];

export const strengths = [
  {
    id: "god-kommunikation",
    title: "God kommunikation",
    icon: "fa-regular fa-comments",
    description: "Du bliver aldrig efterladt i tvivl. Jeg prioriterer løbende dialog, så du altid kender status på dit projekt."
  },
  {
    id: "ordentlighed",
    title: "Ordentlighed",
    icon: "fa-regular fa-handshake",
    description: "Jeg rydder op efter mig, overholder tidsplanen og behandler dit hjem med respekt."
  },
  {
    id: "gennemtaenkte-loesninger",
    title: "Gennemtænkte løsninger",
    icon: "fa-regular fa-compass",
    description: "Jeg ser muligheder, hvor andre ser begrænsninger. Hvert projekt tilpasses dine behov og boligens unikke karakter."
  },
  {
    id: "gennemfoerte-detaljer",
    title: "Gennemførte detaljer",
    icon: "fa-regular fa-circle-check",
    description: "Uanset opgavens størrelse går jeg grundigt til værks og sikrer, at arbejdet er gennemtænkt fra start. Du får en løsning, der fungerer i praksis og fremstår pæn og veludført med sans for de små detaljer."
  },
  {
    id: "vi-holder-aftaler",
    title: "Vi holder aftaler",
    icon: "fa-regular fa-calendar-check",
    description: "En aftale er en aftale. Jeg leverer til tiden og til den aftalte pris – uden overraskelser."
  },
  {
    id: "hoej-kvalitet",
    title: "Kvalitet",
    icon: "fa-regular fa-award",
    description: "Som vinder af DM i Skills har jeg et stærkt fagligt fundament og kan løse selv krævende udfordringer i træ med stor præcision. Jeg kender træet i dybden og går aldrig på kompromis med udførelsen."
  }
];

export const udhuseSubpages = [
  {
    slug: "garage-og-carport",
    title: "Garage og carport",
    icon: "fa-solid fa-warehouse",
    description: "En garage eller carport er mere end bare et praktisk overdække til bilen. Vi bygger arkitektonisk tilpassede garager og carporte i træ, der matcher husets stil og tilbyder ekstra opbevaring, værksted eller redskabsrum."
  },
  {
    slug: "anneks",
    title: "Anneks",
    icon: "fa-solid fa-house-chimney",
    description: "Få ekstra plads på grunden med et fuldisoleret og arkitektonisk gennemtænkt anneks i træ. Perfekt som gæstehus, hjemmekontor eller fristed med høj komfort året rundt."
  },
  {
    slug: "skur",
    title: "Skur",
    icon: "fa-solid fa-tools",
    description: "Skræddersyede redskabsskure i træ, der løser dine opbevaringsbehov og fremstår som en smuk, integreret del af havens miljø."
  }
];

export const nybyggeriSubpages = [
  {
    slug: "sommerhus",
    title: "Sommerhus",
    icon: "fa-solid fa-tree",
    description: "Byg nyt sommerhus i træ tilpasset grunden og dine drømme. Vi tilbyder rådgivning, flot arkitektur, gennemtænkt planløsning og stærke trækonstruktioner til det danske klima."
  },
  {
    slug: "helaarshus",
    title: "Helårshus",
    icon: "fa-solid fa-house-chimney-window",
    description: "Et moderne helårshus i træ er et smukt og stærkt alternativ til et traditionelt murstenshus. Oplev høj designfrihed, et behageligt indeklima og mere bæredygtige materialevalg."
  }
];

export const serviceSubpages = [
  {
    slug: "gulv-vaeg-loft",
    title: "Gulv/væg/loft",
    icon: "fa-solid fa-border-all",
    description: "Montering og renovering af trægulve, lofter (herunder akustiklofter som Troldtekt) og vægbeklædning med præcise samlinger og pæn finish."
  },
  {
    slug: "tag",
    title: "Tag",
    icon: "fa-solid fa-home",
    description: "Udførelse af tagarbejde, reparationer, udskiftning af vindskeder, udhæng og tagrender for en sund og holdbar tagkonstruktion."
  },
  {
    slug: "beklaedning-og-udhaeng",
    title: "Beklædning og udhæng",
    icon: "fa-solid fa-layer-group",
    description: "Flot træbeklædning og udhæng på facade og klink, der beskytter boligen mod vind og vejr og giver et stilrent arkitektonisk udtryk."
  },
  {
    slug: "koekken-og-interioer",
    title: "Køkken og interiør",
    icon: "fa-solid fa-kitchen-set",
    description: "Professionel montering af køkkener samt specialfremstillede snedkerløsninger til inventar, indbyggede skabe og reoler."
  },
  {
    slug: "doere-vinduer",
    title: "Døre/vinduer",
    icon: "fa-solid fa-door-open",
    description: "Udskiftning og montering af døre og vinduer med fokus på korrekt tætning, energivenlighed og præcis tilpasning til boligens stil."
  },
  {
    slug: "terrasser-og-uderum",
    title: "Terrasser og uderum",
    icon: "fa-solid fa-sun",
    description: "Opbygning af eksklusive træterrasser, pergolaer, udestuer og overdækninger tilpasset havens terræn og boligens udgange."
  }
];

export const seoMetadata = {
  "/": {
    title: "Tømrer i Silkeborg, Bording, Ikast, Engesvang & omegn | Munkgaard Træbyg ApS",
    description: "Munkgaard Træbyg ApS er dit tømrerfirma i Bording, Silkeborg, Ikast, Engesvang og omegn. Vi bygger med træ og tillid – kontakt us for et uforpligtende tilbud."
  },
  "/om-os": {
    title: "Om os | Munkgaard Træbyg ApS – Tømrer i Bording, Silkeborg & omegn",
    description: "Munkgaard Træbyg ApS har adresse på Kragelundvej 51, Kragelund ved Silkeborg. Vi udfører kvalitetstømrerarbejde med én fast kontaktperson i Midtjylland."
  },
  "/vores-styrker": {
    title: "Vores styrker | Munkgaard Træbyg ApS",
    description: "Læs om vores styrker: God kommunikation, ordentlighed, gennemtænkte løsninger, gennemførte detaljer, overholdte aftaler og DM i Skills-vinder kvalitet."
  },
  "/vi-tilbyder": {
    title: "Vi tilbyder | Træbyggeri og tømrerarbejde i Midtjylland",
    description: "Se vores ydelser under Vi tilbyder: Udhuse, Tilbygning, Nybyggeri i træ, Totalrenovering og Service i området omkring Silkeborg, Ikast og Bording."
  },
  "/vi-tilbyder/udhuse": {
    title: "Udhuse, Garager, Annekser & Skure | Munkgaard Træbyg ApS",
    description: "Vi opfører udhuse i træ: Garager, carporte, annekser og skure tilpasset boligen og grunden. Høj kvalitet og gennemtænkte detaljer."
  },
  "/vi-tilbyder/udhuse/garage-og-carport": {
    title: "Ny garage og carport i træ | Bording, Silkeborg, Ikast & omegn",
    description: "Få bygget ny garage eller carport i træ med plads til opbevaring eller værksted. Flot håndværk tilpasset dit hus."
  },
  "/vi-tilbyder/udhuse/anneks": {
    title: "Byg Anneks i Træ | Munkgaard Træbyg ApS",
    description: "Få opført et eksklusivt, fuldisoleret anneks i træ på din grund. Perfekt som gæstehus eller hjemmekontor."
  },
  "/vi-tilbyder/udhuse/skur": {
    title: "Skræddersyet Redskabsskur i Træ | Munkgaard Træbyg ApS",
    description: "Vi bygger holdbare og smukke redskabsskure i træ, der passer perfekt til din have og opbevaringsbehov."
  },
  "/vi-tilbyder/tilbygning": {
    title: "Tilbygning i træ | Silkeborg, Bording, Ikast & omegn",
    description: "Få ekstra plads i boligen med en gennemtænkt tilbygning i træ, der falder naturligt ind i husets oprindelige arkitektur."
  },
  "/vi-tilbyder/nybyggeri-i-trae": {
    title: "Nybyggeri i træ – Sommerhuse & Helårshuse | Munkgaard Træbyg ApS",
    description: "Vi opfører nybyggeri med træ som centralt og bærende byggemateriale: Både sommerhuse og helårshuse med stor designfrihed og præcision."
  },
  "/vi-tilbyder/nybyggeri-i-trae/sommerhus": {
    title: "Byg nyt sommerhus i træ | Silkeborg, Bording, Ikast & Midtjylland",
    description: "Skal du bygge et nyt sommerhus i træ? Munkgaard Træbyg ApS tilbyder rådgivning og kvalitetsbyggeri tilpasset dine ønsker."
  },
  "/vi-tilbyder/nybyggeri-i-trae/helaarshus": {
    title: "Helårshus i træ – Et moderne alternativ | Munkgaard Træbyg ApS",
    description: "Overvejer du et helårshus i træ frem for traditionelt murværk? Få et stærkt, smukt og mere bæredygtigt materialevalg med høj komfort."
  },
  "/vi-tilbyder/totalrenovering": {
    title: "Totalrenovering & Modernisering | Munkgaard Træbyg ApS",
    description: "Gennemgribende renovering af ældre boliger med respekt for den oprindelige karakter, gennemtænkte byggeteknikker og tæt dialog."
  },
  "/vi-tilbyder/service": {
    title: "Tømrerservice & Vedligeholdelse | Munkgaard Træbyg ApS",
    description: "Professionel tømrerservice til alle mindre og mellemstore opgaver: Døre, vinduer, tag, gulv, køkken, beklædning og terrasser."
  },
  "/vi-tilbyder/service/gulv-vaeg-loft": {
    title: "Lægning af Gulv, Væg & Lofter | Munkgaard Træbyg ApS",
    description: "Få lagt nyt trægulv eller monteret lofter og vægbeklædning med præcision og pæn finish i Silkeborg og omegn."
  },
  "/vi-tilbyder/service/tag": {
    title: "Tagarbejde & Udskiftning af Udhæng | Munkgaard Træbyg ApS",
    description: "Renovering af tagkonstruktioner, reparationer, vindskeder, udhæng og tagrender. Professionelt tømrerarbejde."
  },
  "/vi-tilbyder/service/beklaedning-og-udhaeng": {
    title: "Træbeklædning & Udhæng | Munkgaard Træbyg ApS",
    description: "Montering og udskiftning af træbeklædning på facader og udhæng. Holdbare løsninger, der beskytter og forskønner din bolig."
  },
  "/vi-tilbyder/service/koekken-og-interioer": {
    title: "Køkkenmontering & Snedkerløsninger | Munkgaard Træbyg ApS",
    description: "Montering af køkkener og speciallavede snedkerløsninger som indbyggede reoler, bænke og skabe med udnyttelse af pladsen."
  },
  "/vi-tilbyder/service/doere-vinduer": {
    title: "Udskiftning af Døre & Vinduer | Munkgaard Træbyg ApS",
    description: "Professionel montering og udskiftning af energivenlige døre og vinduer med perfekt tilpasning og tætning."
  },
  "/vi-tilbyder/service/terrasser-og-uderum": {
    title: "Træterrasse & Uderum | Munkgaard Træbyg ApS",
    description: "Opbygning af eksklusive træterrasser, pergolaer og udestuer tilpasset din have og bolig i Bording, Silkeborg og omegn."
  },
  "/referencer": {
    title: "Galleri & Billeder | Munkgaard Træbyg ApS",
    description: "Se billeder af vores arbejde med træbyggeri, sommerhuse, tilbygninger, udhuse, terrasser og renoveringer i Midtjylland."
  },
  "/galleri": {
    title: "Galleri & Billeder | Munkgaard Træbyg ApS",
    description: "Se billeder af vores arbejde med træbyggeri, sommerhuse, tilbygninger, udhuse, terrasser og renoveringer i Midtjylland."
  },
  "/kontakt": {
    title: "Kontakt os | Munkgaard Træbyg ApS – Få et uforpligtende tilbud",
    description: "Kontakt tømrermester Jacob Munkgaard Sørensen på tlf. +45 30 94 38 90 eller email for en uforpligtende snak om dit byggeprojekt."
  }
};
